import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Retired: revising the working plan now happens in the same workspace the plan
 * was built in, opened from the planner itself.
 *
 * The route stays as a redirect rather than disappearing — it was linkable, and
 * a bookmark or a pasted URL should land somewhere useful instead of a blank
 * not-found.
 */
export const Route = createFileRoute('/$orgSlug/$clientSlug/scenarios_/edit')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$orgSlug/$clientSlug/scenarios',
      params: { orgSlug: params.orgSlug, clientSlug: params.clientSlug },
    })
  },
})
